import Image from 'next/image';
import styled from 'styled-components';

export const StyledImage = styled(Image)<{width: number; height: number}>`
    min-width: ${({width}) => width}px;
    min-height: ${({height}) => height}px;
`;
